export default "__VITE_ASSET__Dpw3YVjT__"